import type { ThemeStateProps } from '@pbk-web/types';

import defaultCss from './default.css?raw';
import playbookImages from './images/playbook';

export const defaultStyles = {
  css: defaultCss,
};

const PLAYBOOK_THEME: ThemeStateProps = {
  name: 'playbook',
  hasSubHeading: true,
  styles: {
    color: {
      primary: {
        100: '62, 34, 52',
        75: '110, 89, 103',
        55: '149, 134, 144',
        35: '188, 178, 184',
        5: '245, 244, 245',
      },
      'accent-1': {
        100: '52, 125, 152',
        75: '105, 164, 185',
        55: '145, 188, 204',
        35: '185, 213, 222',
        5: '245, 249, 250',
      },
      'accent-2': {
        100: '214, 114, 82',
        75: '224, 149, 125',
        55: '233, 178, 160',
        35: '241, 206, 195',
        5: '253, 248, 246',
      },
      'accent-3': {
        100: '11, 46, 90',
        75: '71, 98, 131',
        55: '120, 140, 164',
        35: '168, 182, 196',
        5: '242, 244, 246',
      },
      'accent-4': {
        100: '198, 169, 124',
        75: '212, 191, 158',
        55: '224, 208, 184',
        35: '235, 225, 210',
        5: '252, 250, 248',
      },
      greyscale: {
        100: '0, 0, 0',
        75: '64, 64, 64',
        55: '115, 115, 115',
        35: '166, 166, 166',
        15: '217, 217, 217',
        5: '242, 242, 242',
      },
      text: {
        black: '0, 0, 0',
        1: '62, 34, 52',
        2: '90, 87, 102',
        3: '121, 118, 131',
        4: '150, 147, 157',
      },
      background: {
        dark: '62, 34, 52',
        'mid-1': '246, 239, 230',
        'mid-2': '246, 245, 243',
        light: '255, 255, 255',
      },
      semantic: {
        success: '0, 132, 132',
        info: '28, 79, 184',
        warning: '199, 78, 10',
        error: '221, 51, 51',
        'error-light': '255, 242, 242',
        yellow: '248, 193, 0',
        'info-bg': '232, 237, 248',
        'success-bg': '230, 243, 243',
        'warning-bg': '252, 234, 227',
      },
      'hyperlink-1': '0, 115, 230' as string,
    },
    font: {
      sans: '"ScandiaWeb", sans-serif',
      signature: 'Oooh Baby',
    },
  },
  assets: {
    image: playbookImages,
    fonts: {
      'app-font': '/fonts/scandia/font-styles.css',
      'signature-font': '/fonts/OoohBaby/font-styles.css',
    },
  },
};

const themes: Record<string, ThemeStateProps> = {
  [PLAYBOOK_THEME.name]: PLAYBOOK_THEME,
};

export default themes;
